/* Package JSON Import will be here */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import * as actions from '../../actions/login.Action';
import LoginComponent from './adminLogin.Component';
import { MessageBox } from '../sharedComponent/messageBox';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class AdminLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            isEmailEmpty: false,
            isPasswordEmpty: false
        }
    };

    componentWillMount() {
        this.checkAndNavigatToAnotherPage(this.props.user.loggedIn, this.props.user.roleName);
    }

    checkAndNavigatToAnotherPage(loggedIn, roleName) {
        if (loggedIn) {
            if (roleName === Constants.ADMIN_ROLE_NAME || roleName === Constants.SYSTEM_ADMIN_ROLE_NAME) {
                this.props.history.push("/Security");
            }
            else {
                this.props.history.push("/Projects");
            }
        }
    }

    onChangeEmailOrPassword = (values, isEmail) => {
        if (isEmail === "Email") {
            if (values === "") {
                this.setState({ isEmailEmpty: true })
            }
            else {
                this.setState({ isEmailEmpty: false })
            }
            this.setState({ email: values });
        }
        else {
            if (values === "") {
                this.setState({ isPasswordEmpty: true })
            }
            else {
                this.setState({ isPasswordEmpty: false })
            }
            this.setState({ password: values });
        }
    }

    handleLogin = () => {
        let { isEmailEmpty, isPasswordEmpty } = this.state;
        let checkReduxState = JSON.parse(localStorage.reduxState);
        if (checkReduxState.loginReducer && checkReduxState.loginReducer.user && checkReduxState.loginReducer.user.roleName !== "" && checkReduxState.loginReducer.user.fullName !== "" && checkReduxState.loginReducer.user.loggedIn) {
            MessageBox(checkReduxState.loginReducer.user.fullName + " has logged in another tab, please log out and log in as another user", Constants.ERROR);
        } else {
            let { email, password } = this.state;
            if (email === "") {
                //MessageBox(Constants.ENTER_VALID_USERNAME, Constants.ERROR);
                isEmailEmpty = true;
                this.setState({ isEmailEmpty });
                return;
            } else if (password === "") {
                isPasswordEmpty = true;
                this.setState({ isPasswordEmpty });
                return;
                //MessageBox(Constants.ENTER_VALID_PASSWORD, Constants.ERROR);
            } else {
                let requestData = {
                    UserName: email,
                    Password: password
                };
                let url = ApiUrls.Routes.ACNT_C + ApiUrls.Routes.LGN_M;
                Api.Post(url, requestData, this).then((responseData) => {
                    if (responseData.success) {
                        if (responseData.data.isLoginSuccess) {
                            this.successNavigation(responseData);

                        }
                        else {
                            MessageBox(responseData.message, Constants.ERROR);
                        }
                    }
                    else {
                        MessageBox(responseData.message, Constants.ERROR);
                    }
                });
            }
        }
    }
    successNavigation(responseData) {
        MessageBox(responseData.message, Constants.SUCCESS);
        this.props.login(
            responseData.data.isLoginSuccess,
            responseData.data.firstName,
            responseData.data.lastName,
            responseData.data.fullName,
            responseData.data.email,
            responseData.data.phoneNumber,
            responseData.token,
            responseData.data.userName,
            responseData.data.userId,
            responseData.data.roleId,
            responseData.data.roleName,
            responseData.data.claimValue
        );
        this.checkAndNavigatToAnotherPage(responseData.data.isLoginSuccess, responseData.data.roleName);
    }


    render() {
        const { isPasswordEmpty, isEmailEmpty, email, password } = this.state;
        return (
            <LoginComponent
                {...{
                    login: {
                        isPasswordEmpty,
                        isEmailEmpty,
                        email,
                        password
                    }
                }}
                onChangeEmailOrPassword={this.onChangeEmailOrPassword.bind(this)}
                handleLogin={this.handleLogin.bind(this)}
            />
        );
    };

}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

AdminLogin.displayName = 'AdminLogin';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminLogin));